<script>
  import { getFerryDriverTrack } from '@/api/ferryDriver'
  import dayjs from 'dayjs'
  export default {
    name: 'Trajectory',
    props: {
      driverData: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        markers: [],
        loading: false,
        map: null,
        trajectoryData: [], // 轨迹数据
        parkingSegments: [], // 停车时间片段
        labelsLayer: null,
        polylineLayer: null,
        timer: null,
        worker: null, // 新增worker实例
        startTime: '',
        endTime: ''
      }
    },
    mounted() {
      this.startTimer()
      // Vue2/webpack4兼容Web Worker引入
      if (window.Worker) {
        this.worker = new Worker('workers/trajectoryWorker.js')
        this.worker.onmessage = (e) => {
          this.parkingSegments = e.data
          this.renderTrajectoryMap()
        }
        this.worker.onerror = (err) => {
          console.error('Worker error:', err)
        }
      }
    },
    beforeDestroy() {
      if (this.map) {
        this.map.destroy()
      }
      if (this.worker) {
        this.worker.terminate()
      }
    },
    methods: {
      // 启动定时器
      startTimer() {
        this.timer = setInterval(() => {
          if (window.AMap) {
            clearInterval(this.timer)
            this.initMap()
          }
        }, 500) // 每60秒刷新一次数据
      },
      // 初始化地图
      initMap() {
        this.map = new window.AMap.Map('trajectory-map', {
          resizeEnable: true,
          center: [102.71, 25.01], // 默认中心点，后续会根据数据调整
          zoom: 14,
          viewMode: '2D',
          expandZoomRange: true,
          mapStyle: 'amap://styles/normal'
        })

        // this.labelsLayer= new AMap.LabelsLayer({
        // 	zooms: [3, 20],
        // 	zIndex: 1000,
        // 	collision: false,
        // 	allowCollision: false,
        // });
        // this.labelsLayer.add(this.markers);
        // this.map.add(this.labelsLayer)

        this.map.on('complete', () => {
          console.log('地图加载完成')
          this.getTrajectoryData()
        })
      },

      // 获取轨迹数据
      async getTrajectoryData() {
        this.loading = true
        try {
          // 从路由参数获取司机ID
          const traceId = this.$route.query.traceId
          if (!traceId) {
            this.$message.error('缺少traceId参数')
            return
          }

          // 调用真实API接口获取轨迹数据
          const response = await this.fetchTrajectoryAPI(traceId)
          this.trajectoryData = response.data || []

          this.startTime = dayjs(parseInt(this.trajectoryData[0].locatetime)).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          this.endTime = dayjs(
            parseInt(this.trajectoryData[this.trajectoryData.length - 1].locatetime)
          ).format('YYYY-MM-DD HH:mm:ss')

          // 处理轨迹数据
          // 数据处理交给worker
          if (this.worker) {
            this.worker.postMessage(this.trajectoryData)
          } else {
            // 兼容无worker环境，直接处理
            this.processTrajectoryData()
            this.renderTrajectoryMap()
          }
        } catch (error) {
          console.error('获取轨迹数据失败:', error)
          this.$message.error('获取轨迹数据失败')
        } finally {
          this.loading = false
        }
      },

      // 调用轨迹数据API
      async fetchTrajectoryAPI(traceId) {
        // 使用项目中的API方法
        // 需要导入: import { getFerryDriverTrack } from '@/api/ferryDriver'

        // 获取当前日期作为查询参数（可以根据需要调整）
        // const today = new Date().toISOString().split('T')[0]
        // const params = {
        //   traceId,
        //   date: today // 或从其他地方获取查询日期
        // }

        try {
          const res = await getFerryDriverTrack(traceId)
          if (res.code === 0) {
            return { data: res.data }
          } else {
            throw new Error(res.msg || '获取轨迹数据失败')
          }
        } catch (error) {
          // 如果API调用失败，返回模拟数据用于开发调试
          console.warn('API调用失败，使用模拟数据:', error)
          return this.getMockTrajectoryData()
        }
      },

      // 模拟数据（用于开发调试）
      getMockTrajectoryData() {
        return {
          data: [
            // { id: 1, lat: 25.01, lng: 102.71, timestamp: '2025-01-01 09:00:00', status: 'moving' },
            { id: 2, lat: 25.011, lng: 102.711, duration: 15, status: 'parking' },
            { id: 3, lat: 25.011, lng: 102.711, duration: 15, status: 'parking' },
            { id: 4, lat: 25.011, lng: 102.711, duration: 15, status: 'parking' },
            { id: 5, lat: 25.011, lng: 102.711, duration: 20, status: 'parking' },
            // { id: 6, lat: 25.012, lng: 102.712, timestamp: '2025-01-01 09:25:00', status: 'moving' },
            { id: 7, lat: 25.013, lng: 102.713, duration: 10, status: 'parking' },
            { id: 8, lat: 25.013, lng: 102.713, duration: 10, status: 'parking' },
            { id: 9, lat: 25.013, lng: 102.713, duration: 10, status: 'parking' }
          ]
        }
      },

      // 处理轨迹数据，识别停车时间片段
      processTrajectoryData() {
        // 目前只处理点位，其他字段保留，后续迭代需要
        this.parkingSegments = []

        for (let i = 0; i < this.trajectoryData.length; i++) {
          const point = this.trajectoryData[i]
          const [lng, lat] = point.location.split(',')

          if (point.status === 'parking') {
            if (this.parkingSegments.length === 0) {
              this.parkingSegments.push({
                position: [lng, lat],
                startTime: point.timestamp,
                endTime: point.timestamp,
                duration: point.duration || 0,
                points: [point]
              })
            } else {
              const lastSegment = this.parkingSegments[this.parkingSegments.length - 1]

              // 如果当前点与上一个停车点相同，继续添加到当前片段
              if (
                !this.isFixedParking(
                  {
                    lng,
                    lat
                  },
                  {
                    lat: lastSegment.position[1],
                    lng: lastSegment.position[0]
                  }
                )
              ) {
                this.parkingSegments.push({
                  position: [lng, lat],
                  startTime: point.timestamp,
                  endTime: point.timestamp,
                  duration: point.duration || 0,
                  points: [point]
                })
              } else {
                // 更新当前片段的结束时间和时长
                lastSegment.endTime = point.timestamp
                lastSegment.duration += point.duration || 0
                lastSegment.points.push(point)
              }
            }
          }
        }
      },

      // 判断是否为固定停车（所有点坐标相同）
      isFixedParking(point, lastPoint) {
        return (
          Math.abs(point.lat - lastPoint.lat) < 0.0001 &&
          Math.abs(point.lng - lastPoint.lng) < 0.0001
        )
      },

      // 计算停车时长（分钟）
      calculateDuration(startTime, endTime) {
        const start = new Date(startTime)
        const end = new Date(endTime)
        return Math.round((end - start) / (1000 * 60)) // 转换为分钟
      },

      // 渲染轨迹地图
      renderTrajectoryMap() {
        if (!this.map || !this.parkingSegments || this.parkingSegments.length === 0) return
        // 使用MassMarks渲染海量点
        if (this.massMarks) {
          this.map.remove(this.massMarks)
        }

        const massData = this.parkingSegments.map((seg, index) => ({
          lnglat: seg.position,
          style: index === 0 ? 1 : index === this.parkingSegments.length - 1 ? 2 : 0,
          duration: seg.duration,
          index
        }))

        const styles = [
          {
            url: 'amap-marker.svg', // 可自定义停车点图标URL或用默认圆点
            anchor: new AMap.Pixel(12, 12),
            size: new AMap.Size(24, 24),
            color: '#4ecdc4',
            borderStyle: 'solid',
            borderColor: '#fff',
            borderWidth: 2
          },
          {
            url: 'amap-marker-start.svg', // 可自定义停车点图标URL或用默认圆点
            anchor: new AMap.Pixel(12, 12),
            size: new AMap.Size(24, 24),
            color: '#4ecdc4',
            borderStyle: 'solid',
            borderColor: '#fff',
            borderWidth: 2
          },
          {
            url: 'amap-marker-end.svg', // 可自定义停车点图标URL或用默认圆点
            anchor: new AMap.Pixel(12, 12),
            size: new AMap.Size(24, 24),
            color: '#4ecdc4',
            borderStyle: 'solid',
            borderColor: '#fff',
            borderWidth: 2
          }
        ]
        massData.splice(0, 1)
        this.massMarks = new AMap.MassMarks(massData, {
          opacity: 0.9,
          zIndex: 100,
          style: styles
        })
        this.massMarks.setMap(this.map)

        // 单独处理需要特殊层级的点
        const specialPoint = this.parkingSegments[0]

        var specialmarker = new AMap.Marker({
          position: new AMap.LngLat(specialPoint.position[0], specialPoint.position[1]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          zIndex: 2000,
          icon: 'amap-marker-start.svg'
        })
        this.map.add(specialmarker)

        // for (var i = 0; i < this.parkingSegments.length; i++) {
        // 	const item = this.parkingSegments[i]
        // 	const date = dayjs(item.points[0].locatetime).format('YYYY-MM-DD HH:mm:ss')
        // 	const position=item.position

        // 	var marker = new AMap.LabelMarker({
        // 		name:date,
        // 		position,
        // 		zIndex: i,
        // 		text: {
        // 			content: date,
        // 			direction: 'center'
        // 		}
        // 	});
        // 	this.markers.push(marker);
        // }
        // this.labelsLayer.add(this.markers);

        // 可选：点击点显示详情
        this.massMarks.on('mouseover', (e) => {
          const seg = this.parkingSegments[e.data.index]
          this.showParkingDetails(seg, seg.position)
        })

        specialmarker.on('mouseover', (e) => {
          const seg = this.parkingSegments[0]
          this.showParkingDetails(seg, seg.position)
        })

        // 设置地图中心到第一个点位
        if (this.parkingSegments.length > 0) {
          this.map.setCenter(
            new AMap.LngLat(
              this.parkingSegments[0].position[0],
              this.parkingSegments[0].position[1]
            )
          )
          this.map.setZoom(17)
        }
        // 调整视野
        this.adjustMapView()
      },

      // 显示停车详细信息
      showParkingDetails(segment, position) {
        const infoWindow = new AMap.InfoWindow({
          content: this.createInfoWindowContent(segment),
          offset: new AMap.Pixel(0, -30), // 调整偏移以适应指针高度
          closeWhenClickMap: true
        })

        infoWindow.open(this.map, position)
      },

      // 创建信息窗口内容
      createInfoWindowContent(segment) {
        const time = dayjs(parseInt(segment.points[0].locatetime)).format('YYYY-MM-DD HH:mm:ss')
        return `
        <div class="parking-info">
          <div class="parking-details">
            <div class="detail-item">坐标时间: ${time}</div> 
          </div>
        </div>
      `
      },

      // 创建停车图标
      createParkingIcon(duration) {
        const canvas = document.createElement('canvas')
        canvas.width = 80
        canvas.height = 60 // 增加高度以容纳指针
        const ctx = canvas.getContext('2d')

        // 绘制指针（三角形）
        ctx.beginPath()
        ctx.moveTo(40, 55) // 指针顶点
        ctx.lineTo(30, 40) // 左下角
        ctx.lineTo(50, 40) // 右下角
        ctx.closePath()
        ctx.fillStyle = '#4ecdc4'
        ctx.fill()
        ctx.strokeStyle = '#fff'
        ctx.lineWidth = 1
        ctx.stroke()

        // 绘制主体背景
        ctx.fillStyle = '#4ecdc4'
        ctx.fillRect(0, 0, 80, 40)
        ctx.strokeStyle = '#fff'
        ctx.lineWidth = 2
        ctx.strokeRect(0, 0, 80, 40)

        // 绘制文字
        ctx.fillStyle = '#fff'
        ctx.font = 'bold 12px Arial'
        ctx.textAlign = 'center'
        ctx.fillText('停车', 40, 16)
        ctx.fillText(`${duration}分钟`, 40, 32)

        return canvas.toDataURL()
      },

      // 调整地图视野
      adjustMapView() {
        if (this.parkingSegments.length > 0) {
          const bounds = new AMap.Bounds()

          this.parkingSegments.forEach((segment) => {
            bounds.extend(new AMap.LngLat(segment.position[0], segment.position[1]))
          })

          this.map.setBounds(bounds, false, [20, 20, 20, 20])
        }
      },

      // 返回上一页
      goBack() {
        this.$router.go(-1)
      }
    }
  }
</script>

<template>
  <div class="trajectory-container">
    <div class="trajectory-header">
      <div class="header-left">
        <el-button type="primary" icon="el-icon-arrow-left" size="small" @click="goBack">
          返回
        </el-button>
        <span class="page-title">司机轨迹分析</span>
      </div>
      <div class="header-right">
        <el-tag v-if="parkingSegments.length > 0" type="success" size="small">
          发现 {{ parkingSegments.length }} 个固定停车点
        </el-tag>
      </div>
    </div>
    <div class="date-window" v-if="startTime && endTime">
      <div>开始服务时间：{{ startTime }}</div>
      <div>结束服务时间：{{ endTime }}</div>
    </div>
    <div
      id="trajectory-map"
      v-loading="loading"
      element-loading-text="正在为您加载轨迹数据......"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255,255,255, 0.8)"
      style="width: 100%; height: 100%"
    ></div>

    <!--    <div class="trajectory-legend" v-if="!loading && parkingSegments.length > 0">-->
    <!--      <div class="legend-title">图例说明：</div>-->
    <!--      <div class="legend-items">-->
    <!--        <div class="legend-item">-->
    <!--          <div class="legend-icon fixed-parking"></div>-->
    <!--          <span>固定停车点（连续3次以上相同位置停车）</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<style scoped lang="scss">
  .trajectory-container {
    width: 100%;
    height: calc(100vh - 40px - 96px); // 减去顶部导航和底部间距
    position: relative;
    padding: 20px;

    .date-window {
      position: absolute;
      top: 80px;
      left: 30px;
      z-index: 1112;
      background: rgba(255, 255, 255, 0.8);
      padding: 15px;
      border-radius: 12px;
    }

    .trajectory-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;

      .header-left {
        display: flex;
        align-items: center;
        gap: 12px;

        .page-title {
          font-size: 18px;
          font-weight: 600;
          color: #303133;
        }
      }

      .header-right {
        .el-tag {
          font-size: 12px;
        }
      }
    }

    #trajectory-map {
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      border: 1px solid #e4e7ed;
      height: calc(100% - 56px); // 减去头部高度
    }

    .trajectory-legend {
      margin-top: 16px;
      padding: 12px 16px;
      background: #f9f9f9;
      border-radius: 6px;
      border: 1px solid #e4e7ed;

      .legend-title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 8px;
      }

      .legend-items {
        display: flex;
        gap: 24px;

        .legend-item {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;
          color: #606266;

          .legend-icon {
            width: 16px;
            height: 16px;
            border-radius: 2px;

            &.fixed-parking {
              background-color: #4ecdc4;
            }
          }
        }
      }
    }
  }

  // 地图标注样式优化
  ::v-deep .amap-marker-label {
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  // 信息窗口样式
  ::v-deep .amap-info-window {
    .amap-info-window-content {
      background: rgba(0, 0, 0, 0.8);
      color: white;
      border-radius: 6px;
      padding: 8px 12px;
      font-size: 12px;

      .parking-info {
        .parking-title {
          font-weight: bold;
          margin-bottom: 4px;
          font-size: 13px;
        }

        .parking-details {
          display: flex;
          flex-direction: column;
          gap: 2px;

          .detail-item {
            font-size: 11px;
            opacity: 0.9;
            line-height: 1.4;
          }
        }
      }
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    .trajectory-container {
      padding: 12px;

      .trajectory-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
      }

      #trajectory-map {
        height: 400px !important;
      }

      .trajectory-legend {
        .legend-items {
          flex-direction: column;
          gap: 8px;
        }
      }
    }
  }
</style>
